import { Payment } from './offers/payment';

import { Chat } from './offers/chat';

import { Movizor } from './offers/movizor';

import { Rating } from './offers/rating';

import { Form } from './offers/form';

export default { Payment, Chat, Movizor, Rating, Form };
